import React, { useState } from 'react';
import ErrorPanel from './components/ErrorMessage';
import { useFormContext } from 'react-hook-form';
import CustomScroll from './components/CustomScroll';
import Select from './components/Select';
const Step3 = () => {
    const services = [
        { label: "Aerial Surveys & Inspections", value: "Aerial Surveys & Inspections" },
        { label: "BIM Project Management", value: "BIM Project Management" },
        { label: "Building Surveys", value: "Building Surveys" },
        { label: "CAD-to-BIM", value: "CAD-to-BIM" },
        { label: "COBie & Data Management", value: "COBie & Data Management" },
        { label: "Design & Information Validation", value: "Design & Information Validation" },
        { label: "Digital Construction Consultancy", value: "Digital Construction Consultancy" },
        { label: "Digital Twinning", value: "Digital Twinning" },
        { label: "Fire Risk Assessments", value: "Fire Risk Assessments" },
        { label: "Geospatial Management", value: "Geospatial Management" },
        { label: "Land Surveys", value: "Land Surveys" },
        { label: "Laser Scanning & Virtual Tours", value: "Laser Scanning & Virtual Tours" },
        { label: "Mixed Reality", value: "Mixed Reality" },
        { label: "Photogrammetry", value: "Photogrammetry" },
        { label: "Project Visualisation & Gamification", value: "Project Visualisation & Gamification" },
        { label: "Scan-to-BIM", value: "Scan-to-BIM" },
        { label: "Structural Investigations", value: "Structural Investigations" },
        { label: "Underground Utility Surveys", value: "Underground Utility Surveys" },
        { label: "3D Printing", value: "3D Printing" },
        { label: "4D Simulation", value: "4D Simulation" }
    ];
    //'const [hoveredValue, setHoveredValue] = useState<string | null>(null)
    const { watch } = useFormContext();
    const selectedValue = watch("service");
    const [hoveredValue, setHoveredValue] = useState(null);
    return (React.createElement(CustomScroll, null,
        React.createElement("div", { className: "modal-grid" },
            React.createElement("div", { className: "modal-left-column" },
                React.createElement("h2", null, "Select Service"),
                React.createElement("p", null,
                    "Choose what service fits your project,",
                    React.createElement("br", null),
                    " and we'll ensure the right expertise is applied"),
                React.createElement(Select, { name: "services", options: services, onHover: setHoveredValue }),
                React.createElement(ErrorPanel, { name: "services" })),
            React.createElement("div", { className: "modal-right-column" },
                React.createElement("div", { className: "file-type-stack" },
                    React.createElement("img", { width: "700", height: "600", src: "/assets/images/quote-modal/services/1.webp", alt: "Aerial Surveys & Inspections", className: "img-fluid file-image right-col-image d-none", loading: "lazy" }),
                    React.createElement("span", null, "We offer 20 specialized services designed to deliver accurate solutions. Select all that apply to help us understand which areas you're interested in."),
                    React.createElement("img", { width: "700", height: "600", src: "/assets/images/quote-modal/services/services.webp?v=4", alt: "3d CAD image", className: "img-fluid base-file right-col-image", loading: "lazy" }))))));
};
export default Step3;
